/* eslint-disable prettier/prettier */
let xpcConfig = {
  address: {
    provinceUrl: 'http://demo.recloud.com.cn:99../api/SfaCommon/GetProvinceList',
    cityUrl: 'http://demo.recloud.com.cn:99../api/SfaCommon/GetCityList',
    countyUrl: 'http://demo.recloud.com.cn:99../api/SfaCommon/GetCountyList',
    alias: { id: 'Id', name: 'Name' },
    autoLoad: true
  },
  componentPrefix: 'Rt',
  defaultLocale: 'zh-CN',
  defaultLocaleId: '2052',
  localesUrl: '',
  localesMessageUrl: ''
};

const _ = {};
_.get = () => {
  return xpcConfig;
};
_.assign = mergeConfig => {
  xpcConfig = Object.assign(xpcConfig, mergeConfig);
  return xpcConfig;
};
_.set = (key, value) => {
  xpcConfig[key] = value;
};

export default _;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/config.js